/**
 * Compute the My Partial Sales metric-card counts.
 *
 * The `partialSales` prop for /my_partial_sales contains BOTH the user's own
 * listings and the listings they've expressed interest in as a buyer (EOIs).
 * The owned metrics (total / published / drafts / total clients) must count
 * only the user's own listings — counting the combined array made a buyer EOI
 * (another user's open listing) inflate the "Published" count. The buyer's EOIs
 * are reported separately as `eoiCount`.
 *
 * @param {Array} partialSales - the combined my-partial-sales array
 * @param {number|string} userId - the current user's id
 * @returns {{ total: number, published: number, drafts: number, totalClients: number, eoiCount: number }}
 */
export const myPartialSalesStats = (partialSales, userId) => {
  const list = partialSales || [];
  // ids may arrive as number or string, so compare as strings
  const isOwned = (l) => l && l.user && l.user.id != null && String(l.user.id) === String(userId);
  const owned = list.filter(isOwned);

  return {
    total: owned.length,
    published: owned.filter((l) => l.sale_status === 'open').length,
    drafts: owned.filter((l) => l.sale_status === 'new').length,
    totalClients: owned.reduce((sum, l) => sum + (l.number_of_clients || 0), 0),
    // The controller flags the buyer's own EOIs with current_user_is_an_interest;
    // within this array that is exactly the not-owned set.
    eoiCount: list.filter((l) => l.current_user_is_an_interest === true).length,
  };
};

export default myPartialSalesStats;
